import { render, staticRenderFns } from "./ContractSuspend.vue?vue&type=template&id=1a9a1292"
import script from "./ContractSuspend.vue?vue&type=script&lang=js"
export * from "./ContractSuspend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports